import { Switch } from 'antd';
import styled from 'styled-components';

interface ToggleSwitchProps {
  isChecked: boolean;
  onClick: () => void;
}

export const ToggleSwitch = ({ isChecked, onClick }: ToggleSwitchProps) => {
  return (
    <Container>
      <Label>
        <CustomSwitch value={isChecked} onClick={onClick} />
      </Label>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;

  overflow: hidden;

  padding: 4px 0px;
`;

const Label = styled.label`
  display: inline-block;
  align-items: center;

  position: relative;

  cursor: pointer;
`;

const CustomSwitch = styled(Switch)`
  background-color: #c6c6d5;
`;
